module.exports = __webpack_public_path__ + "img/web-browser@2x.e9b7a96d.png";